import * as XLSX from "xlsx";
import _ from "lodash";

const XlsxHelper = {
  get_header_row: (sheet) => {
    var headers = [];
    var range = XLSX.utils.decode_range(sheet["!ref"]);

    var C,
      R = range.s.r; /* start in the first row */
    /* walk every column in the range */

    for (C = range.s.c; C <= range.e.c; ++C) {
      var cell =
        sheet[
          XLSX.utils.encode_cell({ c: C, r: R })
        ]; /* find the cell in the first row */

      var hdr = "UNKNOWN " + C; // <-- replace with your desired default
      if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);

      headers.push(hdr);
    }
    return headers;
  },
  get_header_row_by_file: async (file) => {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      defval: "",
    });
    return jsonData[0];
  },
};

export default XlsxHelper;
